export type InvoiceLocalisationCode = "IN" | "AE";

export type InvoiceLocalisation = {
  code: InvoiceLocalisationCode;
  /** Broker's registered country; compared against the insurer country. */
  brokerCountry: string;
  currencySymbol: string;
  /** Locale used to group the amounts on the printed invoice. */
  numberLocale: string;
  taxLabel: "GST" | "VAT";
  taxRatePercent: number;
  /** India splits a domestic supply into CGST + SGST; VAT is a single line. */
  hasStateSplit: boolean;
  /** Tax registration label printed under each party. */
  taxIdLabel: string;
};

const LOCALISATIONS: Record<InvoiceLocalisationCode, InvoiceLocalisation> = {
  IN: {
    code: "IN",
    brokerCountry: "India",
    currencySymbol: "₹",
    numberLocale: "en-IN",
    taxLabel: "GST",
    taxRatePercent: 18,
    hasStateSplit: true,
    taxIdLabel: "GSTIN",
  },
  AE: {
    code: "AE",
    brokerCountry: "United Arab Emirates",
    currencySymbol: "$",
    numberLocale: "en-AE",
    taxLabel: "VAT",
    taxRatePercent: 5,
    hasStateSplit: false,
    taxIdLabel: "TRN",
  },
};

const DEFAULT_LOCALISATION_CODE: InvoiceLocalisationCode = "AE";

// Accepts either an ISO code or the country name, in any casing.
const CODE_BY_ENV_VALUE: Record<string, InvoiceLocalisationCode> = {
  IN: "IN",
  IND: "IN",
  INDIA: "IN",
  AE: "AE",
  UAE: "AE",
  "UNITED ARAB EMIRATES": "AE",
};

function resolveLocalisation(): InvoiceLocalisation {
  const rawValue = import.meta.env.VITE_APP_LOCALISATION_COUNTRY?.trim().toUpperCase();
  const code = CODE_BY_ENV_VALUE[rawValue || ""] || DEFAULT_LOCALISATION_CODE;

  return LOCALISATIONS[code];
}

export const INVOICE_LOCALISATION = resolveLocalisation();
